<template>
  <div class="parameter-table">
    <div class="title">
      {{$t('parameterTable.title')}}
    </div>
    <div class="section">
      <div class="head">
        <div>{{$t('parameterTable.number')}}</div>
        <div>{{$t('parameterTable.parameters')}}</div>
        <div>{{$t('parameterTable.value')}}</div>
      </div>
      <div class="body" v-for="(item, index) in parameters" :key="index">
        <div>{{'#' + (index + 1)}}</div>
        <div>{{item.param}}</div>
        <div>{{item.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    let that = this
    return {
      parameters: [
        {param: '1: Block generation speed increased to 0.5 seconds', value: '6 Hours'},
        {param: '1: Do something sexy, like beat the ETH', value: '11.161 DNA'}
      ]
    }
  }
}
</script>
<style lang="less" scoped>
@import url('./NetworkParameterTable.less');
</style>